import { api } from '../../utils/api';

export const getEnterpriseGraphics = async (type, data) => {
  try {
    const response = await api.post(`graphics-dashboard-enterprise?action=${type}`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
}
